import { ProgressPage } from './ProgressPage'

export default ProgressPage
